import React from 'react';
import { Button, TableCell, TableRow } from '@insurancemenu/imenu-components-lib';
import { Download, Share } from '@insurancemenu/imenu-components-lib/dist/icons';
import { normDateToShortAmericanDate } from '@insurancemenu/imenu-components-lib/dist/helpers/dateFormatters';
import clsx from 'clsx';
import { useRootStore } from 'store/rootStore';
import { EdiFile } from 'types/ediService';
import { toJS } from 'mobx';
import { downloadByUrl } from '@insurancemenu/imenu-components-lib/dist/helpers/downloadByUrl';
import { createStyles } from './styles';

interface EdiTableRowProps {
  file: EdiFile;
}

const EdiTableRow = ({ file }: EdiTableRowProps): JSX.Element => {
  const classes = createStyles();

  const { id, generatedFrom: policyIds, fileLocation, creationDate } = file;
  const {
    readyToSendEdisStore: { openModal, buildFileLink },
  } = useRootStore();

  const convertedPolicyIds = policyIds.map((policyId) => toJS(policyId)).slice();

  const download = (): void => {
    downloadByUrl(buildFileLink(id));
  };

  const openSendFileModal = (): void => {
    openModal('SEND_FILE', file);
  };

  const policyIdsList = [...new Set(convertedPolicyIds.map(({ policyId }) => policyId))].map((policyId) => (
    <li key={policyId} className={classes.policyId}>
      {policyId}
    </li>
  ));

  return (
    <TableRow className={classes.tableRow}>
      <TableCell className={clsx(classes.tableCell, classes.longFileInfo)}>{id}</TableCell>
      <TableCell className={clsx(classes.tableCell, classes.longFileInfo)}>
        <ul className={classes.policyIdsList}>{policyIdsList}</ul>
      </TableCell>
      <TableCell className={clsx(classes.tableCell, classes.longFileInfo)}>{fileLocation}</TableCell>
      <TableCell className={classes.tableCell}>
        {creationDate ? normDateToShortAmericanDate(creationDate) : ''}
      </TableCell>
      <TableCell className={classes.tableCell}>
        <Button
          type="text"
          leftIconProp={<Share />}
          color="primary"
          onClick={openSendFileModal}
          className={classes.actionButton}
        >
          Send
        </Button>
      </TableCell>
      <TableCell className={classes.tableCell}>
        <Button
          type="text"
          leftIconProp={<Download />}
          color="primary"
          onClick={download}
          className={classes.actionButton}
        >
          Download
        </Button>
      </TableCell>
    </TableRow>
  );
};

export default EdiTableRow;
